$(document).ready(function() {
    var ulElement = $("#aa");
    var secondLiElement = ulElement.find("span:eq(0)");
    var secondLiContent = secondLiElement.text();
    var yj_price = Number(secondLiContent.substring(1));   
    
    var okba = $("#flag").text();
    var okbb = Number(okba);
    
    var cj_price = 0 ;
    var save_price = 0 ;

    if(yj_price>=99 && yj_price<199){ 
      cj_price = (yj_price-20).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="XWIG20"; 
    }else if(yj_price>=199 && yj_price<299){
      cj_price = (yj_price-50).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="XWIG50";
    }else if(yj_price>=299 && yj_price<399){
      cj_price = (yj_price-70).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="XWIG70";
    }else if(yj_price>=399){
      cj_price = (yj_price-100).toFixed(2);
      save_price = (yj_price-cj_price).toFixed(2);
      saleCode ="XWIG100";  
    }else{ 
      cj_price =  yj_price.toFixed(2);
      save_price = 0;
      saleCode =" "; 
    }


    if(okbb==0){
      var fq_price = (yj_price/4).toFixed(2);
      $("#aa").removeClass("yc_price");
      $("#bb").removeClass("show_price");
      $("#aa").addClass("show_price");
      $("#bb").addClass("yc_price");
    }else{
      var fq_price = (cj_price/4).toFixed(2);
      $("#aa").removeClass("show_price");
      $("#bb").removeClass("yc_price");
      $("#bb").addClass("show_price");
      $("#aa").addClass("yc_price");  
    }

    if(saleCode=="XWIG20"){
      var yhed = "$20";
      var overmn = "$99";

      $("#yc1").addClass("ycang");
      $("#yc2").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");

    }else if(saleCode=="XWIG50"){
      var yhed = "$50";
      var overmn = "$199";

      $("#yc2").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc3").removeClass("ycang");
      $("#yc4").removeClass("ycang");

    }else if(saleCode=="XWIG70"){
      var yhed = "$70";
      var overmn = "$299";

      $("#yc3").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc2").removeClass("ycang");
      $("#yc4").removeClass("ycang");

    }else if(saleCode=="XWIG100"){
      var yhed = "$100";
      var overmn = "$399";

      $("#yc4").addClass("ycang");
      $("#yc1").removeClass("ycang");
      $("#yc2").removeClass("ycang");
      $("#yc3").removeClass("ycang");

    }else{
      var yhed = "0";
      var overmn = ""; 
    }
  
    $("#savePrice").text("$"+save_price);
    console.log(cj_price);
    $("#bb").text("$"+cj_price);
    $("#windows_bb").text("$"+cj_price);
    $("#win_yj_price").text("$"+yj_price);
    $("#win_savePrice").text("$"+save_price);
    $("#ww").text("$"+cj_price);
    $("#sale_code").text(saleCode);
    $("#win_saleCode").text(saleCode);
    $("#price_fq").text("$"+fq_price);
    $("#yhed").text(yhed);
    $("#overmn").text(overmn);
  });